export const paymentPermissionResource = (customer, customerTypes = [], invoice = null) => ({
  ...customer,
  customerTypeName: customer?.customerTypeName || customer?.customer_type_name
    || customerTypes.find((type) => String(type.id) === String(customer?.customertypeid ?? customer?.customerTypeId ?? customer?.type))?.name || '',
  allocations: invoice ? [invoice] : [],
});
